"use strict";

const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");

class ElementResizeDetectionUtility extends EventEmitter {
    constructor() {
        super();

        this._resizeTrigger = document.createElement("object");
        this._resizeTrigger.setAttribute(
            "style",
            "display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1;"
        );
        this._resizeTrigger.onload = this._onObjectLoad.bind(this);
        this._resizeTrigger.type = "text/html";
        this._resizeTrigger.data = "about:blank";

        this._animationFrame = undefined;

        this._resizeListeners = [];

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        this._resizeTrigger = undefined;
        if (!_.isUndefined(this._animationFrame)) {
            cancelAnimationFrame(this._animationFrame);
        }
        this._animationFrame = undefined;
        this._resizeListeners = undefined;
        return Promise.resolve();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /**
     * Using requestAnimationFrame, trigger resize events for the element that was passed in via
     * addResizeListener
     * @param event {Event} - Resize event from the 'object' tag
     * @private
     */
    _onObjectContentDocumentResize(event) {
        if (!_.isUndefined(this._animationFrame)) {
            cancelAnimationFrame(this._animationFrame);
        }
        this._animationFrame = requestAnimationFrame(() => {
            this._resizeListeners.forEach((fn) => {
                fn.call(this._resizeTrigger, event);
            });
        });
    }

    /**
     *
     * @param event {Event} - The load event for the 'object' element
     * @private
     */
    _onObjectLoad(/*event*/) {
        this._resizeTrigger.contentDocument.defaultView.addEventListener(
            "resize",
            this._onObjectContentDocumentResize.bind(this)
        );
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * Add a resize listener to the passed in DOM element and execute the passed in callback function on resize
     * @param element {HTMLElement} - The DOM element that should have the 'object' element injected into it
     * @param callback {Function} - The function to execute on resize
     */
    addResizeListener(element, callback) {
        if (getComputedStyle(element).position === "static") {
            element.style.position = "relative";
        }
        if (element.contains(this._resizeTrigger) === false) {
            element.appendChild(this._resizeTrigger);
        }
        this._resizeListeners.push(callback);
    }

    /**
     * Remove the callback function from the _resizeListeners queue
     * @param element {HTMLElement} - The DOM element that has the resize logic applied to it
     * @param callback {Function} - The function to be removed from the _resizeListeners queue
     */
    removeResizeListener(element, callback) {
        this._resizeListeners.splice(this._resizeListeners.indexOf(callback), 1);
        if (this._resizeListeners.length === 0) {
            if (this._resizeTrigger.contentDocument !== null) {
                this._resizeTrigger.contentDocument.defaultView.removeEventListener(
                    "resize",
                    this._onObjectContentDocumentResize
                );
            }
            element.removeChild(this._resizeTrigger);
        }
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ElementResizeDetectionUtility;
